// select reducers
export const selectProductReducer = (state, action) => {
  state.selectedProduct = action.payload;
};

export const selectCategoryReducer = (state, action) => {
  state.selectedCategory = action.payload;
};

export const selectQuoteReducer = (state, action) => {
  state.selectedQuote = action.payload;
};

export const setDefaultSelectedQuoteReducer = (state, action) => {
  state.addQuoteProduct.defaultSelectedQuote = action.payload || '';
};

export const selectQuoteProductReducer = (state, action) => {
  const { product, sendTogether, quoteOrgId } = action.payload;
  state.selectedQuoteProduct.value = { ...product, ...(quoteOrgId ? { quote_org_id: quoteOrgId } : {}) };
  state.selectedQuoteProduct.sendTogether = sendTogether;
};

export const importAttachmentsReducer = (state, action) => {
  state.importedAttachments = [...state.importedAttachments, ...action.payload];
};

export const removeImportedAttachmentReducer = (state, action) => {
  const { id } = action.payload;
  if (id) {
    const importedAttachments = [...state.importedAttachments];
    const fileIndex = importedAttachments.findIndex((item) => item.id === id);
    if (fileIndex >= 0) {
      importedAttachments.splice(fileIndex, 1);
      state.importedAttachments = importedAttachments;
    }
  }
};

export const resetImportedAttachmentsReducer = (state) => {
  state.importedAttachments = [];
};

// reset reducers
export const resetSelectedCategoryReducer = (state) => {
  state.selectedCategory = {};
};

export const resetProductsReducer = (state) => {
  state.products.value = [];
  state.products.next = null;
  state.products.loading = true;
  state.products.initialised = true;
};

export const resetCategoriesReducer = (state) => {
  state.categories.value = [];
  state.categories.next = null;
  state.categories.loading = true;
  state.categories.initialised = false;
};

export const resetSelectedQuoteSetReducer = (state) => {
  state.selectedQuoteSet = {};
};

export const resetQuotesReducer = (state) => {
  state.quotes = {
    next: null,
    loading: true,
    value: [],
    initialised: false,
  };
};
